// Unpublished Work © 2023-2024 Deere & Company

import React, { useContext } from "react";
import { Navigate, useLocation, useSearchParams } from "react-router";
import { DealerAccountContext } from "../../../context/DealerAccountContext";
import { ALL_ACCOUNTS } from "../../../utils/constants";

function RedirectToNewUrlWrapper({ children }: { children: React.ReactNode }) {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const { updateSelectedAccounts, mappedAccounts } =
    useContext(DealerAccountContext);

  const updateDealerAccountContextIfRequired = (accountId: string | null) => {
    if (!mappedAccounts || accountId === ALL_ACCOUNTS) {
      return;
    }
    const dealerAccount = mappedAccounts.find(
      (value) => value.id === accountId
    );
    if (dealerAccount) {
      updateSelectedAccounts([dealerAccount]);
    }
  };

  // For claims, invoices, handling units, eligibilities and credit status modules
  if (searchParams.get("accountId")) {
    const accountId = searchParams.get("accountId");
    updateDealerAccountContextIfRequired(accountId);
    const remainingQueryParams = new URLSearchParams(searchParams);
    remainingQueryParams.delete("accountId");
    return (
      <Navigate
        to={`${location.pathname}${
          remainingQueryParams.toString()
            ? `?${remainingQueryParams.toString()}`
            : ""
        }${location.hash}`}
        state={location.state}
        replace
      />
    );
  }

  // For all other modules
  if (location.pathname.startsWith("/dealer")) {
    updateDealerAccountContextIfRequired(location.pathname.split("/")[2]);
    return (
      <Navigate
        to={`/${location.pathname.split("/").slice(3).join("/")}${
          searchParams.toString() ? `?${searchParams.toString()}` : ""
        }`}
        state={location.state}
        replace
      />
    );
  }

  return children;
}

export default RedirectToNewUrlWrapper;
